import React, {useContext} from "react"
import AssociateDetail from "./AssociateDetail";
import Breadcrumb, {BreadcrumbGroup} from "@amzn/meridian/breadcrumb";
import {FormattedMessage} from "react-intl";
import Row from "@amzn/meridian/row";
import {AssociateContext} from "./context/AssociateContextProvider";

const AssociateDetailView = () => {
    const {associateViewModel, associateModelDispatcher} = useContext(AssociateContext)

    const resetAssociateSelection = () => {
        associateModelDispatcher({type: "RESET_ASSOCIATE_SELECTION"})
    }

    return (
        <div>
            <Row widths="100%" spacingInset="large large small">
                <BreadcrumbGroup>
                    <Breadcrumb onClick={() => resetAssociateSelection()}>
                        <FormattedMessage id="routeInfo.stage" defaultMessage="Stage"/>
                    </Breadcrumb>
                    <Breadcrumb>
                        <FormattedMessage id="associate.associate_detail" defaultMessage="Associate Detail"/>
                    </Breadcrumb>
                </BreadcrumbGroup>
            </Row>
            {associateViewModel.associate.map(associate => (
                <AssociateDetail key={associate} associate={associate}/>
            ))}
        </div>
    )
}

export default AssociateDetailView





// WEBPACK FOOTER //
// ./src/components/associate/AssociateDetailView.js